<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/sheri-lawa.jpg" alt="Sheri Lawal">
          </figure>
        <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-four.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Sheri Lawal</h2>
      <p class="job-title">Careers Adviser</p>  

        <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

        <p>Hi everyone! I’m Sheri Lawal and I’ve recently joined MMU as a new Careers Adviser for the Science & Engineering team. My previous roles have centred around providing careers information, advice and guidance in various educational settings (mainly to university, college and school-aged students). In my spare time, it is my pleasure to volunteer as a mentor and I also love travelling, photography and hiking.</p>

        <p class="profile-statement-interviewer">What inspires you within your role?</p>

        <p>I spent most of my early career working to increase the aspirations of young people and demystify university. I now work in careers and employability, and I am passionate empowering students to make the best professional and personal choices for them.</p>

        <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

        <p>I love to embrace the food and music of course! But more importantly I love the belly laughs, sense of belonging and an unspoken understanding we have as a community.</p>

        <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work? </p>

        <p>For me it is when my passion, values and happiness align. I bring my “whole self to work” when the things that are important to me (values) and me being comfortable and happy in the workplace (wellbeing) come together.</p>

        <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

        <p>Shine a light on the talent, ideas, contributions of BAME staff and students. Also provided safe spaces to share lived experiences and forge connections (with the wider community)</p>

        <p class="profile-statement-interviewer">What are you most proud of?</p>

        <p>I am most proud of my family and our unyielding resilience through challenging times.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;

    & figure {
      text-align: left;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>